// 江苏
export const PROVINCE_ID = 320000
// 南京
export const CITY_ID = 320100
// 滑块的生产key
export const AppKey = '189937877'
